import {memo} from 'react';

import styled from 'styled-components';

import {flexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {body14Bold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import Button from '~/shared/components/Button';

const BalanceErrorWrapper = styled.div`
  ${flexCenterVertically}
`;

const BalanceErrorText = styled.div`
  color: ${({theme}) => theme.colors.contentError};
  ${body14Bold}
`;

const RetryButton = styled(Button)`
  padding: 5px 16px;
  border-radius: 16px;
  height: 32px;
  line-height: 20px;
  border: 1px solid ${({theme}) => theme.colors.borderStrong};
  color: ${({theme}) => theme.colors.contentDefault};
  ${body14Bold}
  ${flipOnLTR`
    margin-right: 12px;
  `}
`;

const CreditLoadingFailed = ({onRetry}: {onRetry: () => void}) => {
  const {t} = getLocalizationService();
  return (
    <BalanceErrorWrapper>
      <BalanceErrorText>{t('credit_balance_loading_failed')}</BalanceErrorText>
      <RetryButton onClick={onRetry}>{t('try_again_2')}</RetryButton>
    </BalanceErrorWrapper>
  );
};

export default memo(CreditLoadingFailed);
